import React from "react";
import PageHeader from "../../components/ui/PageHeader";
import Card from "../../components/ui/Card";

const PartnersPage: React.FC = () => {
    return (
        <div className="page-content">
            <PageHeader
                title="Партнеры"
                description="Управление партнерами, токенами, разрешенными сайтами и IP-адресами."
            />

            <Card>
                <h3 className="card-title">Партнерские доступы</h3>
                <p className="card-text">
                    Здесь будет список партнеров, создание нового партнера и перевыпуск токена.
                </p>
            </Card>
        </div>
    );
};

export default PartnersPage;
